var chunkToChildrenMap = {
	"src_components_base_index_jsx-src_components_topnav_components_base_topnav_basetopnav_css-src-6519bd": [
		"webpack_container_remote_account_themeModal"
	],
	"src_components_topnav_components_base_topnav_basetopnav_css-src_components_topnav_components_-06e31a": [
		"webpack_container_remote_account_themeModal"
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };